<template>
<v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn large block color="info" v-on="on"><v-icon left>playlist_add_check</v-icon>{{ $t('Columns') }}</v-btn>
    </template>

    <v-card>
      <v-card-title
        primary-title
      >
        {{ $t('Columns') }}
      </v-card-title>

      <v-card-text>
        <template v-for="(column, index) in columns">
          <div class="d-flex align-center" :key="column.value">
            <v-checkbox
              v-model="column.visible"
              hide-details
              :label="$t(column.text)"
              class="mt-0"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn icon @click="moveUp(index)">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn icon @click="moveDown(index)">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
          </div>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as Reports from '@/modules/reports/reports'
// import * as LocalStorage from '@/core/local-storage'
import * as arrayMove from 'array-move'
// import * as Admin from '@/core/admin'
import * as Utils from '@/core/utils'
// import { app } from '@/main'
import { UserDetail } from '@/core/userDetail'
import * as Security from '@/core/security'

export default {
  props: ['value'],
  data () {
    return {
      userDetailFilterColumns: null,
      dialog: false,
      loading: false,
      columns: [...Reports.columns]
    }
  },
  watch: {
    columns: {
      handler (val) {
        if (!this.loading) {
          // console.log('--> Saving User Detail from PICKER', this.userDetailFilterColumns, JSON.stringify(val))
          if (this.userDetailFilterColumns !== null) {
            this.userDetailFilterColumns.Data1 = JSON.stringify(val)
            this.userDetailFilterColumns.save()
          }
          // LocalStorage.save(user.token.User + 'columns', JSON.stringify(val))
          this.$emit('input', this.columns)
        }
      },
      deep: true
    }
  },
  async mounted () {
    this.loading = true
    await Security.autoLogin()// Make sure we are logged in, since user is needed to get filters (User Details)
    await this.loadColumns()
    this.$emit('input', this.columns)
    this.loading = false
  },
  methods: {
    async loadColumns () {
      // console.log('--> USER ID from PICKER', Security.user.id)
      this.userDetailFilterColumns = await UserDetail.load(Security.user.id, 'ReportRegistrationColumnsFilter')
      // console.log('--> Loaded User Detail from PICKER', this.userDetailFilterColumns)
      // console.log('--> Columns loaded! ', filter)
      if (Utils.isJsonString(this.userDetailFilterColumns.Data1)) {
        this.columns = JSON.parse(this.userDetailFilterColumns.Data1)

        // XNET-6611: If saved columns from db and Report.columns do not match, then merge them in Report order
        if (this.columns.length !== Reports.columns.length) {
          let merged = []
          Reports.columns.forEach(item => {
            const old = this.columns.filter(s => s.text === item.text)
            if (old.length) merged = merged.concat(old) // use old settings
            else merged = merged.concat(item) // use new settings
          })
          this.columns = merged
        }
      } else {
        this.userDetailFilterColumns.Data1 = this.columns
      }
    },
    moveUp (index) {
      this.columns = arrayMove(this.columns, index, index - 1)
    },
    moveDown (index) {
      this.columns = arrayMove(this.columns, index, index + 1)
    }
  }
}
</script>
